/**
 * @file
 * Remove target="_blank" from links.
 *
 * For some reason, the Extlink module does not remove the target="_blank" attribute from links,
 * even though the "Open in new window" option is NOT selected. This behavior is fixed here.
 */

(function (Drupal, $, once) {
  Drupal.behaviors.cleanLinks = {
    attach: function (context) {
      const links = once('clean-links', 'a', context);

      $(links).each(function () {
        let $link = $(this);

        if ($link.attr('target') === '_blank') {
          $link.removeAttr('target');
        }
      });

    }
  };
})(Drupal, jQuery, once);
